import { useMemo } from "react";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { PropertyOptionalParam } from "web_myplann/Portfolio/Hooks/useGetPropertyOptionalParams";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

export const useBooleanGroupOptions = <T>(
	params: PropertyOptionalParam<T>[],
): FlatRowSelectOption<string>[] => {
	const { t } = useResource();

	return useMemo(
		() =>
			params.map(({ key, label }) => ({
				value: String(key),
				label: t(label),
			})),
		[params, t],
	);
};
